import { useState } from "react";
import { CreatedExternalUser } from "./CreateExternalUserInlineForm";
import { ICreateExternalUserInlineSectionProps } from "./CreateExternalUserInlineSection";

export function useCreateExternalUserInlineSection(props: ICreateExternalUserInlineSectionProps) {
    const [isFormVisible, setIsFormVisible] = useState(false);

    const onCreated = (created: CreatedExternalUser) => {
        setIsFormVisible(false);
        props.onCreated(created);
    };

    return {
        isFormVisible,
        toggleForm: () => setIsFormVisible(!isFormVisible),
        onCreated,
    };
}
